import React, { useEffect } from "react";
import { Box, Card, Typography } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";

const MaintenancePopup = ({ open }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: { xs: 56, sm: 64 },
        left: { xs: 0, md: 240 },
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(15, 23, 42, 0.60)",
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Card
        elevation={0}
        sx={{
          maxWidth: 520,
          width: "100%",
          p: 6,
          borderRadius: 4,
          textAlign: "center",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(102, 126, 234, 0.5)",
        }}
      >
        {/* Animated background elements */}
        <Box
          sx={{
            position: "absolute",
            top: -50,
            right: -50,
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.1)",
            animation: "float 6s ease-in-out infinite",
            "@keyframes float": {
              "0%, 100%": { transform: "translate(0, 0)" },
              "50%": { transform: "translate(-20px, 20px)" },
            },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -30,
            left: -30,
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.08)",
            animation: "float 8s ease-in-out infinite",
            animationDelay: "1s",
          }}
        />

        {/* Icon with animation */}
        <Box
          sx={{
            mb: 3,
            display: "inline-flex",
            p: 3,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            border: "2px solid rgba(255, 255, 255, 0.3)",
            position: "relative",
            zIndex: 1,
            animation: "rotate 3s linear infinite",
            "@keyframes rotate": {
              "0%": { transform: "rotate(0deg)" },
              "100%": { transform: "rotate(360deg)" },
            },
          }}
        >
          <BuildIcon sx={{ fontSize: 56, color: "white" }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            mb: 2,
            color: "white",
            position: "relative",
            zIndex: 1,
            textShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          Under Maintenance
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: "rgba(255, 255, 255, 0.9)",
            lineHeight: 1.7,
            position: "relative",
            zIndex: 1,
            fontSize: "1.05rem",
          }}
        >
          We're upgrading our systems to serve you better. Our team is working hard to bring everything back online.
        </Typography>

        {/* Animated progress bar */}
        <Box
          sx={{
            width: "100%",
            height: 4,
            borderRadius: 2,
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            overflow: "hidden",
            position: "relative",
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              width: "40%",
              height: "100%",
              borderRadius: 2,
              background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent)",
              animation: "slide 2s ease-in-out infinite",
              "@keyframes slide": {
                "0%": { transform: "translateX(-100%)" },
                "100%": { transform: "translateX(400%)" },
              },
            }}
          />
        </Box>

        {/* Estimated time */}
        <Typography
          variant="caption"
          sx={{
            mt: 3,
            display: "block",
            color: "rgba(255, 255, 255, 0.7)",
            position: "relative",
            zIndex: 1,
            fontSize: "0.9rem",
          }}
        >
          Thank you for your patience
        </Typography>
      </Card>
    </Box>
  );
};

export default MaintenancePopup;